import { render, staticRenderFns } from "./MyNav.vue?vue&type=template&id=2d162858&scoped=true&"
import script from "./MyNav.vue?vue&type=script&lang=js&"
export * from "./MyNav.vue?vue&type=script&lang=js&"
import style0 from "./MyNav.vue?vue&type=style&index=0&id=2d162858&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d162858",
  null
  
)

export default component.exports